import React, { useEffect } from "react";
import { useTranslation } from "ceco-polyglot";
import { Header } from "../../components/cecoadmin-panel";
import FullWidthLayout from "../../layout/FullWidthLayout";
import { createRefetchContainer } from "react-relay";
import Recipe from "../../components/Recipe";
import CreateButton from "../../components/CreateButton";
import graphql from "babel-plugin-relay/macro";

const SingleRecipePage = (props) => {
  const {
    menuExpanded,
    setMenuExpanded,
    children,
    match,
    relay,
    query: {
      recipe,
      allCategories,
      allIngredients,
      allUnitMeasure,
      allRecipeIngredients,
      configConstance,
      allWarnings,
      allAllergen,
      summaryIngredient,
    },
    ...rest
  } = props;

  const _refetch = (id) => {
    relay.refetch(
      id ? { id: id } : null,
      null,
      () => {
        // Refetch Done
      },
      { force: true }
    );
  };

  const t = useTranslation();
  useEffect(() => {
    document.title = `Recetario Mambo - ${t("title.recipes")}`;
  }, [t]);

  return (
    <FullWidthLayout>
      <Header
        title={t("title.recipe")}
        menuExpanded={menuExpanded}
        setMenuExpanded={setMenuExpanded}
      >
        <CreateButton allCategories={allCategories} />
      </Header>
      <Recipe
        allWarnings={allWarnings}
        configConstance={configConstance}
        recipe={recipe}
        allCategories={allCategories}
        allIngredients={allIngredients}
        allUnitMeasure={allUnitMeasure}
        allAllergen={allAllergen}
        allRecipeIngredients={allRecipeIngredients}
        summaryIngredient={summaryIngredient}
        refetchData={_refetch}
        {...rest}
      />
    </FullWidthLayout>
  );
};
// export default SingleRecipePage;
export default createRefetchContainer(
  SingleRecipePage,
  {
    query: graphql`
      fragment SingleRecipePage_query on Query
      @argumentDefinitions(id: { type: "ID!" }) {
        recipe(id: $id) {
          name
          ...Recipe_recipe
        }

        summaryIngredient: allRecipeIngredients(
          recipe: $id
          ingredient: "summary"
        ) {
          ...StepRecipeModal_summaryIngredient
          ...IngredientsSummaryList_summaryIngredient
        }

        allRecipeIngredients(recipe: $id, orderBy: "id") {
          edges {
            node {
              id
              comments
              ingredient {
                id
                name
              }
              unityF {
                id
              }
              qty
              section {
                id
                name
              }
              fraction
            }
          }
        }

        allCategories {
          ...DropdownCategories_allCategories
        }

        allWarnings {
          ...StepRecipeModal_allWarnings
        }
        configConstance {
          ...StepRecipeModal_configConstance
        }
        allIngredients {
          ...IngredientRecipeModal_allIngredients
        }
        allUnitMeasure {
          ...IngredientRecipeModal_allUnitMeasure
        }
        allAllergen {
          ...AllergenRecipeModal_allAllergen
        }
      }
    `,
  },
  graphql`
    query SingleRecipePageRefetchQuery($id: ID!) {
      recipe(id: $id) {
        ...Recipe_recipe
      }

      summaryIngredient: allRecipeIngredients(
        recipe: $id
        ingredient: "summary"
      ) {
        ...IngredientsSummaryList_summaryIngredient
      }

      allRecipeIngredients(recipe: $id, orderBy: "id") {
        edges {
          node {
            id
            comments
            ingredient {
              id
              name
            }
            unityF {
              id
            }
            qty
            section {
              id
              name
            }
          }
        }
      }
    }
  `
);
